// Fixed (non-CSS-variable) copies of this app's own real design tokens -
// src/index.css :root / default "grass" accent, light-theme values only.
// Literal hex, not var(--x): these strings end up in two places that can't
// resolve a CSS custom property at all - clipboard/Excel HTML pasted into
// Google Sheets/Word/Excel (outside this app's document entirely), and the
// Table/Print PDF/PNG capture, which is deliberately always a light sheet
// regardless of the viewer's own dark-mode setting (see
// TournamentExportModal.js's own comment on why Tabular/Print mode never
// follows the live theme, unlike Screenshot Mode). --primary-green itself
// doesn't change between the app's light/dark themes either (only
// surfaces/text do - see index.css), so picking its one real value here
// isn't a "light theme only" compromise the way --primary-color/--white
// etc. below are.
export const PRINT_THEME = {
    primaryGreen: "#539447",
    darkerGreen: "#4a8340",
    whiteGreen: "#c2ecbc",
    ink: "#1c1c1c",
    muted: "#9ea4ac",
    // No mid-gray token exists in the app's own light-theme palette (ink is
    // near-black, muted is light grey-blue) - this one's specific to the
    // PDF card/title banners (group label, draw name), picked to read as
    // gray rather than black while keeping white banner text legible.
    headerGray: "#5b6472",
    white: "#ffffff",
    superWhite: "#f7f8fa",
    border: "#e5e7eb",
    alarm: "#af3f40",
    ball: "#d1d646",
    radius: "5px",
    fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
};
